import "core-js/modules/es.error.cause.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05b34994"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import { addTenantUser, updateTenantUser } from '@/api/user';
import { ElMessage } from 'element-plus';
export default {
  __name: 'TenantUser',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    tenantId: {
      type: [String, Number],
      required: true
    },
    formSchemas: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const isVisible = useVModel(props);
    const formSchemasRef = ref(props.formSchemas);
    const originFormData = {};
    formSchemasRef.value.forEach(item => {
      // eslint-disable-next-line
      originFormData[item['field']] = item['defaultValue'];
      if (item['field'] === 'password') {
        originFormData['confirmPassword'] = '';
      }
    });
    const confirmPasswordRules = [{
      validator: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请重新输入密码'));
        } else if (value !== formData.value.password) {
          callback(new Error('两次密码输入不一致'));
        } else {
          callback();
        }
      }
    }];

    // 表单数据
    const formData = ref({
      ...originFormData,
      tenantId: props.tenantId
    });
    const resetForm = () => {
      formData.value = originFormData;
    };
    watch(() => props.model, async val => {
      if (val) {
        // const res = await userRoles(val.id)

        formData.value = {
          id: val.id,
          userName: val.userName,
          password: '',
          tenantId: val.tenantId
          // userRoleList: res.map((item) => item.name)
        };
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });

    // 表单元素
    const formEl = ref(null);
    const loading = ref(false);
    const handleAddNewData = async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          loading.value = true;

          // 版本号
          try {
            var _props$formSchemas$fi;
            const userRoleList = (_props$formSchemas$fi = props.formSchemas.find(item => item.field === 'userRoleList').checkboxArr) === null || _props$formSchemas$fi === void 0 ? void 0 : _props$formSchemas$fi.filter(item => formData.value.userRoleList.includes(item.name)).map(item => ({
              roleId: item.id
            }));
            let data;
            if (!props.model) {
              if (!formData.value.password) {
                return ElMessage.error('密码不能为空');
              }
              data = userRoleList.length ? {
                ...formData.value,
                userRoleList: userRoleList
              } : formData.value;
              await addTenantUser(data);
            } else {
              data = userRoleList.length ? {
                ...formData.value,
                userRoleList: userRoleList.map(item => ({
                  roleId: item.roleId,
                  userId: props.model.id
                }))
              } : formData.value;
              if (!data.password) delete data.password;
              await updateTenantUser(data);
            }
            ElMessage.success(`${(props.model ? '修改' : '新增') + '成功'}`);
            emits('refreshData');
            resetForm();
          } catch (error) {
            console.log(error);
          } finally {
            loading.value = false;
            isVisible.value = false;
          }
        }
      });
    };
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改租户用户' : '新增租户用户',
        onClosed: closed,
        "destroy-on-close": "",
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddNewData,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formSchemas, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.component === 'Input' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createVNode(_component_el_form_item, {
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                maxlength: item.minlength || '',
                "show-word-limit": item.shoWordLimit,
                disabled: item.disabled,
                type: item.field === 'password' ? 'password' : 'text'
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "maxlength", "show-word-limit", "disabled", "type"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"]), item.field === 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "确认密码",
              prop: "confirmPassword",
              rules: confirmPasswordRules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value.confirmPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.confirmPassword = $event),
                placeholder: "请再次输入密码",
                type: item.field === 'password' ? 'password' : 'text'
              }, null, 8, ["modelValue", "type"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), item.component === 'InputTextArea' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                type: "textarea",
                autosize: {
                  minRows: 3
                },
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputNumber' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                min: 1,
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'DateInterval' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                "unlink-panels": "",
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                size: "default",
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Radio' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                disabled: item.disabled
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.radioArr, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    key: index,
                    label: item.value,
                    border: ""
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Select' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: item.label,
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                style: {
                  "width": "100%"
                },
                disabled: item.disabled
              }, {
                default: _withCtx(() => [_createElementVNode("template", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))])]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : _createCommentVNode("", true), item.component === 'Cascader' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_cascader, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                options: _ctx.tenantData,
                clearable: "",
                props: _ctx.cascaderProps,
                "show-all-levels": false,
                filterable: "",
                style: {
                  "width": "40%"
                },
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "props", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Checkbox' && item.checkboxArr.length ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.checkboxArr, (v, i) => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    key: i,
                    label: v.name,
                    border: "",
                    style: {
                      "margin-bottom": "10px"
                    }
                  }, null, 8, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};